export const COLORS = {
  SUCCESS: '#11CA7B',
  ERROR: '#F32445',
  SECONDARY: '#888FA9',
  INFO: '#9576FF',
  WARNING: '#ffad2c',
};

export const EXPORT_COLOR_MAP = {
  normal: COLORS.SUCCESS,
  over: COLORS.ERROR,
};

export const SAVED_SEARCH_COLOR_MAP = {
  normal: COLORS.SUCCESS,
  over: COLORS.WARNING,
};
